import {Canvas, View} from '@react-pdf/renderer';

import {LineChart} from './LineChart';
import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {PillarData} from '../../../../../../types/ApplicantScreeningReport';
import {SupportedLanguages} from '../../../../../../types/SupportedLanguages';

interface Props {
  lang: SupportedLanguages;
  pillars: PillarData[];
}

export const LineChartReport = ({lang, pillars}: Props) => {
  const createLineChart = (doc: any, width: number, height: number) => {
    const applicantValues: number[] = [];
    const companyValues: number[] = [];
    const colors = [greenColors[100], orangeColors[100]];
    const columnNames: string[] = [];
    const rowNames: number[] = [1, 2, 3, 4, 5, 6];

    pillars.forEach((pillar) => {
      applicantValues.push(pillar.score.screeningApplicant);
      companyValues.push(pillar.score.company);
      columnNames.push(pillar.title[lang]);
    });

    const Chart = new LineChart({
      doc,
      width,
      height,
      colors,
      columnNames,
      rowNames,
      dataSets: [applicantValues, companyValues],
    });
    Chart.create();

    return null;
  };

  return (
    <View>
      <Canvas
        style={{
          position: 'relative',
          height: '140px',
          width: '283px',
        }}
        paint={createLineChart}
      />
    </View>
  );
};
